module.exports = function(h, row) {
    return row.user.name;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/audit_trail/columns/user.jsx